import { render, staticRenderFns } from "./GetPublicGroup.vue?vue&type=template&id=6b4604fd&scoped=true&"
import script from "./GetPublicGroup.vue?vue&type=script&lang=js&"
export * from "./GetPublicGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4604fd",
  null
  
)

export default component.exports